import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <ContactSection />
        <TopicsSection />
        <RankingSection />
        <CommentsSection />
        <CardsSection />
        <FAQSection />
        <FeaturesSection />
        <IndexSection />
        <MediaSection />
        <AppSection />
        <AboutSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}